import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './components/MainPage';
import TelemetryPage from './components/TelemetryPage';
import HomeHealth from './components/HomeHealth';
import AllCourses from './components/AllCourses';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/all-courses" element={<MainPage />} />
        <Route path="/telemetry" element={<MainPage />} />
        <Route path="/home-health" element={<MainPage />} />
      </Routes>
    </Router>
  );
};

export default App;